import { useRef, useState } from "react";
import ReactCrop, {
  centerCrop,
  convertToPixelCrop,
  Crop,
  makeAspectCrop,
} from "react-image-crop";

import 'react-image-crop/dist/ReactCrop.css';

export const ASPECT_RATIO = 1;
export const MIN_DIMENSION = 150;
export const CROPPED_IMAGE_DIMENSION = 200;

export function ImageCropper({ imgSrc, handleClose, uploadImage, isCircular = true }: { imgSrc: string, handleClose: () => Promise<void>, uploadImage: (file: File) => Promise<void>, isCircular?: boolean }) {
    const imgRef = useRef<HTMLImageElement | null>(null);
    const [crop, setCrop] = useState<Crop | undefined>(undefined);
    const [isSaving, setIsSaving] = useState(false);

    const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
        const { width, height } = e.currentTarget as HTMLImageElement;
        const cropWidthInPercent = (MIN_DIMENSION / width) * 100;

        const crop = makeAspectCrop(
            {
            unit: "%",
            width: cropWidthInPercent,
            },
            ASPECT_RATIO,
            width,
            height
        );
        const centeredCrop = centerCrop(crop, width, height);
        setCrop(centeredCrop);
    };

    const handleUpdateImage = async () => {
        setIsSaving(true);
        const image = imgRef.current
        if (!image || !crop) {
            throw new Error('Crop canvas does not exist')
        }

        const pixelCrop = convertToPixelCrop(crop, image.naturalWidth, image.naturalHeight)
        
        const offscreen = new OffscreenCanvas(
            CROPPED_IMAGE_DIMENSION,
            CROPPED_IMAGE_DIMENSION,
        )

        const ctx = offscreen.getContext('2d')

        if (!ctx) {
            throw new Error('No 2d context')
        }

        ctx.drawImage(
            image,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            CROPPED_IMAGE_DIMENSION,
            CROPPED_IMAGE_DIMENSION
        )

        const blob = await offscreen.convertToBlob({
            type: 'image/jpeg',
        })

        const file = new File([blob], "profile.jpg", { type: "image/jpeg" });

        await uploadImage(file);
        await handleClose();
        setIsSaving(false);
    }


    return (
    <>
        {imgSrc && (
        <div className="flex flex-col items-center">
            
            <ReactCrop
            crop={crop}
            onChange={(pixelCrop, percentCrop) => setCrop(percentCrop)}
            circularCrop={isCircular}
            keepSelection
            aspect={ASPECT_RATIO}
            minWidth={MIN_DIMENSION}
            className="max-h-[60vh]"
            >
                <img
                    ref={imgRef}
                    src={imgSrc}
                    alt="Upload"
                    onLoad={onImageLoad}
                />
            </ReactCrop>
            
            <button
            className="text-white font-mono text-xs py-2 px-4 rounded-2xl mt-4 bg-sky-500 hover:bg-sky-600"
            onClick={handleUpdateImage}
            >
            Crop Image
            </button>
            {isSaving && <p>Saving...</p>}
        </div>
        )}
    </>
    );
}